import { Component, OnInit } from '@angular/core';
import { LoginService } from '@intranet/modules/login/login.service';
import {
    RolesService,
    SimpleUser,
    SimpleRole,
    SimpleUserRole,
} from '@intranet/core/services/roles.service';
import { HotkeyService } from 'src/app/core/services/hotkey.service';

class UserWithRoles extends SimpleUser {
    public roles: SimpleRole[];
}

@Component({
    selector: 'admin-roles',
    templateUrl: './admin-roles.component.html',
    styleUrls: ['./admin-roles.component.scss'],
})
export class AdminRolesComponent implements OnInit {
    isLoading: boolean = false;
    users: UserWithRoles[];
    roles: SimpleRole[];
    userroles: SimpleUserRole[];
    error: string;
    addDialogOpen: boolean = false;
    newRoleName: string;
    sortBy: string = 'name';
    sortDir: 'asc' | 'desc' = 'asc';


    constructor(
        private rolesService: RolesService,
        public loginService: LoginService,
        private hotkeyService: HotkeyService
    ) {}

    ngOnInit(): void {
        // Register hotkey for "Cancel" action (Ctrl + Q)
        this.hotkeyService.registerHotkey('ctrl+q', 'Cancel action', () => this.onCancel());

        // Register hotkey for "Add Role" (Ctrl + Shift + A)
        this.hotkeyService.registerHotkey('ctrl+shift+a', 'Add Role', () => {
            this.showAddRoleDialog();
        });

        // Register hotkey for "Save Role" (Ctrl + Alt + S)
        this.hotkeyService.registerHotkey('ctrl+alt+s', 'Save Role', () => {
            if (this.addDialogOpen && this.newRoleName) {
                this.addNewRole();
            }
      });


        this.getRoleMembers();
    }

    getRoleMembers() {
        this.error = '';
        this.rolesService.getRoleMembers().subscribe(
            (r) => {
                if (r.success) {
                    this.roles = r.roles;
                    this.userroles = r.userRoles;
                    this.users = r.users.map((u) => {
                        return this.makeUserWithRoles(u);
                    });
                    this.sortUsers();
                } else {
                    this.error = r.error;
                }
            },
            (error) => (this.error = error)
        );
    }

    onSort(column: string) {
        if (this.sortBy === column) {
            this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortBy = column;
            this.sortDir = 'asc';
        }

        this.sortUsers();
    }

    sortUsers() {
        this.users.sort((a, b) => {
            let valueA: any;
            let valueB: any;

            if (this.sortBy === 'name') {
                valueA = a.firstName.toLowerCase() + ' ' + a.surname.toLowerCase();
                valueB = b.firstName.toLowerCase() + ' ' + b.surname.toLowerCase();
            } else if (this.sortBy === 'userName') {
                valueA = a.userName.toLowerCase();
                valueB = b.userName.toLowerCase();
            }

            return this.sortDir === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
        });
    }


    showAddRoleDialog() {
        this.addDialogOpen = true;
    }

    cancelAddDialog() {
        this.addDialogOpen = false;
    }

    addNewRole() {
        this.rolesService.addNewRole(this.newRoleName).subscribe(
            (r) => {
                if (r.success) {
                    this.getRoleMembers();
                } else {
                    this.error = r.error;
                }
            },
            (error) => (this.error = error)
        );
        this.addDialogOpen = false;
    }

    getRolesToEdit(): SimpleRole[] {
        return this.roles.filter((r) => r.name != 'User');
    }

    makeUserWithRoles(user: SimpleUser): UserWithRoles {
        var roles = this.userroles.filter((ur) => ur.userId === user.id);
        var uroles: SimpleRole[] = [];
        for (var i = 0; i < roles.length; i++) {
            var sr = this.roles.find((r) => r.roleId === roles[i].roleId);
            if (sr) {
                uroles.push(sr);
            }
        }
        return {
            userName: user.userName,
            surname: user.surname,
            firstName: user.firstName,
            id: user.id,
            shortName: user.shortName,
            roles: uroles,
        };
    }

    isInRole(user: UserWithRoles, role: string): boolean {
        return (
            user.roles.find(
                (r) => r.name.toLowerCase() === role.toLowerCase()
            ) !== undefined
        );
    }

    toggleRole(user: UserWithRoles, role: SimpleRole) {
        if (user.roles.find((r) => r.roleId === role.roleId)) {
            this.rolesService
                .removeUserFromRole(user.id, role.roleId)
                .subscribe(
                    (r) => {
                        if (r.success) {
                            this.getRoleMembers();
                        } else {
                            this.error = r.error;
                        }
                    },
                    (error) => (this.error = error)
                );
        } else {
            this.rolesService.addUserToRole(user.id, role.roleId).subscribe(
                (r) => {
                    if (r.success) {
                        this.getRoleMembers();
                    } else {
                        this.error = r.error;
                    }
                },
                (error) => (this.error = error)
            );
        }
    }

    onCancel(): void {
        this.addDialogOpen = false;
        this.error = '';
    }

    cancelDialog() {
        this.error = '';
    }
}
